<template>
  <div class="information">
    <div class="mbx">
      <Breadcrumb :path="path"></Breadcrumb>
    </div>
    <div class="fl"></div>
    <div class="information-conten">
      <img :src="avatar" alt="" v-if="avatar != ''" />
      <img src="@/assets/img/形状_16_拷贝_2.png" alt="" v-else />
      <van-uploader :after-read="afterRead">
        <div class="information-conten-upload">修改头像</div>
      </van-uploader>
      <div class="form">
        <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
          <a-form-model-item prop="name" style="margin-bottom: 25px">
            <div class="components-input-demo-presuffix">
              <span>姓名</span>
              <a-input
                v-model="ruleForm.name"
                placeholder="请输入姓名"
                style="padding-left: 10px"
              ></a-input>
            </div>
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            prop="sov"
            style="margin-bottom: 25px"
          >
            <div class="select">
              <span>*</span>
              <span>身份</span>
              <a-select
                :options="options"
                style="width: 322px"
                v-model="ruleForm.sov"
                @change="selectBlur"
              >
                <!-- <img src="@/assets/img/△.png" alt="" slot="suffixIcon" /> -->
              </a-select>
            </div>
          </a-form-model-item>
          <div class="sex">
            <span class="span">*</span>
            <div class="sex-left">性别</div>
            <div class="sex-right">
              <div
                class="sex-right-sex"
                @click="handoffSex(true)"
                :style="{ 'margin-right': '26px' }"
              >
                <img src="@/assets/img/radio_red.png" alt="" v-if="sex" />
                <img src="@/assets/img/radio_bai.png" alt="" v-else />
                <span>男</span>
              </div>
              <div class="sex-right-sex" @click="handoffSex(false)">
                <img src="@/assets/img/radio_red.png" alt="" v-if="!sex" />
                <img src="@/assets/img/radio_bai.png" alt="" v-else />
                <span>女</span>
              </div>
            </div>
          </div>
          <div class="button">
            <div class="button-left" @click.stop="save">保存</div>
            <div class="button-right" @click.stop="cancellation">取消</div>
          </div>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { message } from "ant-design-vue";
import { $get_user_info, $get_identity, $edit_user_info, $upload } from "@/api";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      // 表单数据
      ruleForm: {
        name: "", // 姓名
        sov: "", // 身份
      },
      // 表单验证规则
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "change" }],
        sov: [{ required: true, message: "请选择身份", trigger: "change" }],
      },
      // 身份的选择器数据
      options: [],
      sex: true, // 性别 true男 false女
      avatar: "", // 头像地址
      uploadAvatar: "", // 上传头像的地址
    };
  },
  mounted() {
    this.getDate();
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          if (document.documentElement.clientWidth < 767) {
            this.$router.push({ name: "informations" });
          }
        });
      })();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  computed: {
    path() {
      let arr = [
        { name: "我的", names: "feedback" },
        { name: "个人信息", names: "information" },
      ];
      return arr;
    },
  },
  methods: {
    // 获取数据
    async getDate() {
      try {
        let res = await $get_user_info();
        this.avatar = res.data.avatar;
        this.ruleForm.name = res.data.real_name;
        this.ruleForm.sov = res.data.identity;
        this.sex = res.data.gender == 1 ? true : false;

        let res1 = await $get_identity();
        this.options = res1.data.map((item) => ({
          value: item.id,
          label: item.identity_name,
        }));
      } catch (error) {}
    },
    // 文件上传完毕后会触发 after-read 回调函数
    async afterRead(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      try {
        let res = await $upload(formData);
        this.avatar = res.data.url;
        this.uploadAvatar = res.data.image;
      } catch (error) {}
    },
    // 切换性别
    handoffSex(bolle) {
      if (bolle == this.sex) {
        return;
      }
      this.sex = !this.sex;
    },
    // 身份切换
    selectBlur() {
      this.$refs.ruleForm.validateField("sov", (valid) => {
        if (valid) {
          console.log("验证通过");
        } else {
          return false;
        }
      });
    },
    // 点击保存按钮
    save() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let params = {
            avatar: this.uploadAvatar,
            real_name: this.ruleForm.name,
            identity: this.ruleForm.sov,
            gender: this.sex ? 1 : 2,
          };
          let res = await $edit_user_info(params);
          if (this.windowWidth() > 767) {
            message.success("保存成功", 1);
          } else {
            this.$toast.success("保存成功");
          }
          this.getDate();
          this.$store.dispatch("permissions/isUpdate", true);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 点击取消按钮
    cancellation() {
      this.$refs.ruleForm.resetFields();
      this.getDate();
    },
  },
};
</script>

<style lang="less" scoped>
.information {
  .mbx {
    padding-top: 30px;
    padding-left: 37px;
    margin-bottom: 21px;
  }

  .fl {
    width: 98%;
    height: 1px;
    background: #e9e9e9;
    margin: 0 auto;
    margin-bottom: 51px;
  }

  .information-conten {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      margin-bottom: 6px;
      width: 105px;
      height: 106px;
      border-radius: 50%;
    }

    .information-conten-upload {
      width: 101px;
      height: 39px;
      background: #333333;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 32px;
    }

    .form {
      .components-input-demo-presuffix {
        position: relative;

        /deep/.ant-input {
          width: 266px;
          height: 38px;
          padding-left: 42px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #a9a9a9;
        }

        span {
          position: absolute;
          top: -5%;
          left: -20%;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }

      .select {
        position: relative;

        /deep/.ant-select-selection--single {
          width: 266px;
          height: 38px;
          display: flex;
          // justify-content: flex-end;
          align-items: center;

          .ant-select-selection__rendered {
            margin-right: 42px;
          }

          .ant-select-selection-selected-value {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #a9a9a9;
          }
        }

        /deep/.ant-select {
          width: 266px !important;
          height: 38px;
        }

        span:nth-child(1) {
          position: absolute;
          top: 55%;
          transform: translateY(-50%);
          left: -26%;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #e11a1a;
          z-index: 1;
        }

        span:nth-child(2) {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -19%;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          z-index: 1;
        }
      }

      .sex {
        position: relative;
        height: 50px;
        padding: 18px 16px;
        padding-left: 0;
        padding-top: 0;
        margin-bottom: 23px;

        .span {
          position: absolute;
          top: 35%;
          transform: translateY(-50%);
          left: -26%;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #e11a1a;
          z-index: 1;
        }

        .sex-left {
          position: absolute;
          top: 2%;
          left: -19%;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .sex-right {
          display: flex;

          .sex-right-sex {
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
              width: 18px;
              height: 18px;
              object-fit: cover;
              margin-right: 4px;
              margin-bottom: 0;
            }

            span {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #666666;
            }
          }
        }
      }

      .button {
        display: flex;

        .button-left {
          cursor: pointer;
          width: 128px;
          height: 47px;
          background: #e60012;
          border-radius: 4px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
        }

        .button-right {
          cursor: pointer;
          width: 128px;
          height: 47px;
          background: #e1e1e1;
          border-radius: 4px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>